import { Avatar, Box, Image, Text, useDisclosure } from '@chakra-ui/react';
import { Flex } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useData } from '../../data';
import ShareContentModal from '../modal/ShareContentModal';
import RequestLists from '../notification/RequestLists';
import FounderBanner from '../../public/images/founder_dashboard.png';
import BrandButton from '../brandButton/BrandButton';
import { FaShareAlt } from 'react-icons/fa';

const ActiveDeals = ({ openDealFlowData, setOpenDealFlowData }) => {
  const navigate = useNavigate();
  const viewDetails = (id, companyId) => {
    navigate(`/view-user?userid=${id}&usertype=${1}&cid=${companyId}`);
    // onToggle();
  };
  const userDetails = useSelector((state) => state?.user?.userInfo);
  const loggedInUserType = userDetails?.userTypeTitle || '';
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box className="flex flex-col w-full bg-white rounded-xl">
      <Box className="p-3 mb-3 shadow-lg">
        <Text className="text-lg font-bold">Actively Raising 🔥</Text>
      </Box>
      <Box className="flex flex-col gap-2 p-3 max-h-[calc(90vh-90px)] overflow-y-auto hide-scroll pb-4">
        {openDealFlowData.map((item) => (
          <>
            <Box
              cursor="pointer"
              onClick={() => viewDetails(item.user_id, item.company_id)}
              style={{ flex: '1 1 300px' }}
              className="w-[100%] max-w-[300px] px-3 pt-3 pb-3 relative border border-[#DBE2ED] rounded-lg"
            >
              <ShareContentModal
                isOpen={isOpen}
                onClose={onClose}
                message={`Hi! Check out ${item.user.first_name} ${item.user.last_name} ${!item.user.first_name && !item.user.last_name ? `this user's` : ''} profile on SeedAFounder`}
                link={`${process.env.REACT_APP_FRONTEND_URL}public/profile?userid=${item.user_id}&usertype=1&cid=${item.company_id}`}
                header={'Share Profile'}
                subject={'Hello! Check out this profile on SeedAFounder.'}
              />
              <Flex className="flex-col relative">
                <Box
                  className="rounded-md"
                  w="100%"
                  h="80px"
                  bg="lightgray"
                  position="relative"
                >
                  {item.user?.cover_image && (
                    <Box
                      className="rounded-md"
                      position="absolute"
                      top="0"
                      w="100%"
                      h="80px"
                      overflow="hidden"
                    >
                      <Image
                        src={item.user?.cover_image}
                        //   src="https://images.unsplash.com/photo-1579353977828-2a4eab540b9a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8c2FtcGxlfGVufDB8fDB8fA%3D%3D&w=1000&q=80"
                        objectFit="cover"
                        position="absolute"
                        top="0"
                      />
                    </Box>
                  )}
                  {!item.user?.cover_image && (
                    <Box
                      className="rounded-md"
                      h="120px"
                      w="100%"
                      overflow="hidden"
                    >
                      <Image
                        src={FounderBanner}
                        objectFit="cover"
                        h="80px"
                        className="object-left"
                      />
                    </Box>
                  )}
                </Box>
                <Box className="flex flex-col px-3">
                  <Box className="w-full flex justify-end" mt="-25px">
                    <Avatar
                      w={'40px'}
                      h={'40px'}
                      className="border-white border-[2px]"
                      name={item.company?.title}
                      src={item.user.profile_image}
                    />
                  </Box>
                </Box>
                <Flex className="flex-col p-3 gap-2" w="100%">
                  <Box w="90%">
                    <Flex
                      w="95%"
                      className="relative mt-[-22px] space-between"
                      justifyContent={'space-between'}
                      overflow="hidden"
                    >
                      <Text
                        className="font-semibold"
                        textOverflow="ellipsis"
                        whiteSpace="nowrap"
                        overflow="hidden"
                        fontSize="1rem"
                      >
                        {`${item.company.title}`}
                      </Text>
                    </Flex>
                  </Box>

                  <Box>
                    <Box className="flex gap-2 flex-wrap mb-1 pb-4 border-b border-[#E9E9E9] min-h-[75px] items-start">
                      {/* {item.company?.company_stage?.map(({title}) => <Box className="bg-[#FFE3AC] border border-1.5 text-[9px] font-medium border-[#EC981C] p-1 whitespace-nowrap px-2 min-w-[60px] rounded-full text-center">{title}</Box> )} */}
                      {item.company?.company_stage?.length > 0 ? (
                        <Box className="bg-[#FFE3AC] border border-1.5 text-[9px] font-medium border-[#EC981C] p-1 whitespace-nowrap px-2 min-w-[60px] rounded-full text-center">
                          {item.company?.company_stage[0].title}
                        </Box>
                      ) : null}
                      {item.company.fund_category?.title ? (
                        <Box className="bg-[#DDFBE7] border border-1.5 text-[9px] font-medium border-[#8BDCAD] p-1 whitespace-nowrap px-2 min-w-[60px] rounded-full text-center">
                          {item.company.fund_category?.title}
                        </Box>
                      ) : null}
                      {/* {item.company?.incorporation_location?.map(({name}) => <Box className="bg-[#DBE2ED] border border-1.5 text-[9px] font-medium border-gray-200 p-1 whitespace-nowrap px-2 min-w-[60px] rounded-full text-center">{name}</Box> )} */}
                      {item.company?.incorporation_location?.length > 0 ? (
                        <Box className="bg-[#DBE2ED] border border-1.5 text-[9px] font-medium border-gray-200 p-1 whitespace-nowrap px-2 min-w-[60px] rounded-full text-center">
                          {item.company?.incorporation_location[0]?.name}
                        </Box>
                      ) : null}
                    </Box>
                  </Box>
                  <Box
                    justifyContent={'space-around'}
                    className="w-full flex space-around items-center mb-2 gap-2.5"
                  >
                    <Box className="flex flex-col items-center gap-1 col-span-2">
                      <Text className="text-[10px] text-[#C0BCBC]">
                        Deal Target
                      </Text>
                      <Text
                        className="text-lg font-medium"
                        whiteSpace="nowrap"
                        overflow="hidden"
                      >
                        {item?.amount_committed
                          ? `$${item?.amount_committed}`
                          : '-'}
                      </Text>
                    </Box>
                    <Box className="flex flex-col items-center gap-1 col-span-2">
                      <Text className="text-[10px] text-[#C0BCBC]">
                        Deal Investors
                      </Text>
                      <Text
                        className="text-lg font-medium"
                        whiteSpace="nowrap"
                        overflow="hidden"
                      >
                        {item.no_of_investors || '-'}
                      </Text>
                    </Box>
                  </Box>
                  <Flex className="justify-between w-full gap-2 items-center">
                    <BrandButton
                      w={'100%'}
                      // isLoading={mutateIsLoading}
                      fontSize="13px"
                      py={2}
                      text="View Profile"
                      color="#20B962"
                      borderColor="#20B962"
                      bg="#FFF"
                      _hover={{ backgroundColor: 'green.50' }}
                      height="36px"
                      onClick={() => viewDetails(item.user_id, item.company_id)}
                    />

                    {loggedInUserType === 'investor' ? (
                      <Box
                        onClick={(e) => {
                          e.stopPropagation();
                          onOpen();
                        }}
                        className="w-min text-[#134A70] h-full cursor-pointer border px-2 py-3 rounded-lg"
                      >
                        <FaShareAlt />
                      </Box>
                    ) : null}
                  </Flex>
                </Flex>
              </Flex>
            </Box>
          </>
        ))}
      </Box>
    </Box>
  );
};

export default ActiveDeals;
